<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<div class="block">
<p class="nonindent"><em>This story is dedicated to my wife, Pat.<br/>Heroines are alive and well today</em>—<em>thank God!</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780812589085_epub_ded_r1.vue?d0bb1820